export type ValidationFieldError = {
    field: string;
    messages: string[];
};

export class ValidationError extends Error {
    errors: ValidationFieldError[];

    constructor(errors: ValidationFieldError[]) {
        super('Validation failed');
        this.name = 'ValidationError';
        this.errors = errors;
    }
}
